import { InjectionToken } from '@angular/core';

/**
 * Router segments of the page that lists *all* matches for a query. The global
 * search bar deep-links here (forwarding the query as the `q` query param) when
 * the user asks to see every result instead of picking a single suggestion.
 * Optional — defaults to the top-level `/search` page (AysHomeSearchComponent
 * from `home-lib`, mounted at the app root).
 */
export const BD_GLOBAL_SEARCH_RESULTS_ROUTE = new InjectionToken<string[]>(
  'BD_GLOBAL_SEARCH_RESULTS_ROUTE',
);
